
// Lastly, we import everything and export a single object

import enUsTranslations from './en-us'
import huHUTranslations from './hu-hu'

export default {
  'en-US': enUsTranslations,
  'hu-HU': huHUTranslations
}